/**
 * Client-side mirror of the server's ROOM_ERROR_CODES
 * (src/server/validation/RoomOptionsSchema.ts) — kept as a mirror because
 * client code doesn't import server modules (arch boundary). Keep the two
 * in sync when adding codes.
 */

/** Close code → short human name (diagnostics surfaces). */
export const CLOSE_CODE_NAMES: Record<number, string> = {
  1000: 'Clean close',
  4000: 'Ghost cleanup',
  4001: 'Bad token',
  4002: 'No character',
  4003: 'Server init',
  4004: 'DB error',
  4005: 'Room full',
  4006: 'Bad payload',
};

/**
 * Join rejections that are TERMINAL for the current credentials: rejoining
 * with the same token/characterId is guaranteed to fail again, so the
 * client must NOT auto-reconnect — it should surface the problem instead.
 * (4003/4004/4005 are transient server conditions — retrying those is
 * correct; 1000/4000 are intentional closes handled separately.)
 */
export const TERMINAL_JOIN_REJECT_MESSAGES: Record<number, { title: string; action: string }> = {
  4001: {
    title: 'Authentication failed',
    action: 'Your session token was rejected — reload the page to re-login.',
  },
  4002: {
    title: 'Character not found',
    action: 'The server has no character with this id — reload and pick a class.',
  },
  4006: {
    title: 'Invalid join request',
    action: 'The join payload was malformed — reload the page.',
  },
};
